import { render, staticRenderFns } from "./NestedComments.vue?vue&type=template&id=fb126222&"
import script from "./NestedComments.vue?vue&type=script&lang=js&"
export * from "./NestedComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports